export default {
  basepath: 'https://ckysmall.ckc8.com/',
  buriedpointpath: 'https://ckysby.ckc8.com/', // 埋点接口域名
  downloadpath: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ckc.ckys.ckmanager', // 创客app下载地址
  downloadshoppath: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ckc.ckys', // 商城app下载地址
  datacenterpath: 'https://ckysmall-wx.ckc8.com/', // 社区主页-数据中心三个接口独立域名，运维让改的-正式域名：https://ckysmall-wx.ckc8.com
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
  cosuploadpath: 'https://ckyscommon.ckc8.com/',
  cosaccesspath: 'https://ckyscdn.ckc8.com/Uploads/',
  // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
  staticImgUrl: 'https://ckysrestatic.ckc8.com/', // 图片地址
  ossImgUrl: 'https://staicpcifile.oss-cn-shanghai.aliyuncs.com/' // 图片地址
}



// WEBPACK FOOTER //
// ./src/assets/config/path_prod.js